
















import {Component, Provide, Vue} from 'vue-property-decorator';
import {State, Action} from 'vuex-class';
import UserState from '@/store/modules/user/types';

@Component({})
export default class HomeHeader extends Vue {

    @State('user') public userState: UserState;

    @Action public logout: any;

}
